<% var component = new Anvil.models.components.ActionList(field) %>
<% if ('inline' in field && field.inline) { %>
<div anvil-component="<%- component.id %>" class="col">
	<ul class="list-group<% if ('horizontal' in field && field.horizontal) { %> list-group-horizontal<% } %>" <% if ('attributes' in field) for (let key in field.attributes) { %><%- key %>="<%- field.attributes[key] %>" <% } %>>
		<% if ('options' in field && 'render' in field) for (let [key, option] of field.options) { %>
		<li class="list-group-item list-group-item-action <% if (form.data[field.name] == key) { %>active<% } %>" data-value="<%= key %>"><%- field.render(option) %></li>
		<% } %>
	</ul>
</div>
<% } else { %>
<div anvil-component="<%- component.id %>" class="form-group row">
	<div class="col-<%= ('label_width' in form.params) ? form.params.label_width : '4' %>">
		<label for="<%= form.name %>_<%= field.name %>" class="control-label"><%= field.title %></label>
	</div>
	<div class="col">
		<ul class="list-group<% if ('horizontal' in field && field.horizontal) { %> list-group-horizontal<% } %>">
			<% if ('options' in field && 'render' in field) for (let [key, option] of field.options) { %>
			<li class="list-group-item list-group-item-action <% if (form.data[field.name] == key) { %>active<% } %>" data-value="<%= key %>"><%- field.render(option) %></li>
			<% } %>
		</ul>
		<% if ('help' in field) { %><small class="form-text text-muted"><%- field.help %></small><% } %>
		<div class="invalid-feedback"></div>
	</div>
</div>
<% } %>
